var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9226 13.2505C21.9737 12.8408 22 12.4234 22 11.9999C22 11.5868 21.9749 11.1795 21.9263 10.7795L2.36639 14.6915C2.59092 15.4968 2.91372 16.2612 3.32106 16.9708L21.9226 13.2505Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5889 14.847L4.24631 18.3155C6.08001 20.564 8.87231 21.9999 12 21.9999C16.5337 21.9999 20.3627 18.9828 21.5889 14.847Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07372 13.2204C2.02505 12.8204 2 12.4131 2 12C2 11.5765 2.02633 11.1591 2.07745 10.7494L20.6789 7.02905C21.0863 7.7387 21.4091 8.50307 21.6336 9.30841L2.07372 13.2204Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7537 5.68441C17.92 3.43588 15.1277 2 12 2C7.4663 2 3.63726 5.01705 2.41113 9.15292L19.7537 5.68441Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMoon);
export default __webpack_public_path__ + "static/media/new-moon.44f2c331af0e4cd649adce8e290dd789.svg";
export { ForwardRef as ReactComponent };